import React, {useContext} from "react";
import Shipments from "../Shipments/Shipments";
import {useLocation, useNavigate} from "react-router-dom";
import UiContext from "../../../contexts/UiContext";
import {SocketContext} from "../../../contexts/SocketContext";
import SupplierContext from "../../../contexts/SupplierContext";
import UserContext from "../../../contexts/UserContext";
import VendorContext from "../../../contexts/VendorContext";

type Props = {};

export const ShipmentsWrapper = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);
    const vendorModel = useContext(VendorContext);

    const location = useLocation();
    const navigate = useNavigate();

    const uiContext = useContext(UiContext);
    const socket = useContext(SocketContext)!;

    return <Shipments
        location={location}
        history={navigate}
        notifyFn={uiContext.notifyFn}
        getSidebarState={uiContext.getSidebarState}
        socket={socket}
        toggleSidebar={uiContext.toggleSidebar}
        setSidebarComponent={uiContext.setSidebarComponent}
        setActivityIndicator={uiContext.setActivityIndicator}
        supplierModel={supplierModel}
        userModel={userModel}
        vendorModel={vendorModel}
    />;
};
